<template>
  <div id="toaster">
    <transition-group name="toasts-list" tag="ul">
      <li
        class="toasts-list-item"
        v-for="toast in toasts" 
        :key="toast.id" 
      >
        <toast-message :toast="toast" @remove="remove"/>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useToastsStore } from '../../stores/toasts';
import ToastMessage from './ToastMessage.vue';

export default {
  name: "TheToaster",

  components: {
    ToastMessage
  },
   
  computed: {
      ...mapState(useToastsStore, ["toasts"])
  },

  methods: {
    ...mapActions(useToastsStore, ["remove"])
  }
}
</script>

<style scoped>
#toaster {
  position: absolute;
  bottom: 2em;
  right: 2em;
  z-index: 1100;
}

#toaster > ul {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.toasts-list-item {
  transition: all 0.3s;
}

.toasts-list-enter, .toasts-list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>